// This file is auto-generated by @hey-api/openapi-ts

/**
 * ISIC API version.
 */
export const IsicapiVersionEnum = { '3_7': '3.7', '1_0': '1.0' } as const;

/**
 * ISIC API version.
 */
export type IsicapiVersionEnum = typeof IsicapiVersionEnum[keyof typeof IsicapiVersionEnum];
